import {
  AppStatusIncident,
  AppStatusIncidentInput,
} from '@src/main/modules/app_status/domain/appStatusIncident.model';
import { AppStatusIncidentResponseDto } from '@src/main/modules/app_status/infrastructure/dto/appStatusIncident.dto';

export const toAppStatusIncident = (response: AppStatusIncidentResponseDto): AppStatusIncident => ({
  auditFields: response.auditFields,
  code: response.code,
  date: response.date,
  errorDescription: response.errorDescription ?? '',
  errorDescriptionImage: null,
  errorDescriptionImageUrl: response.errorDescriptionImageUrl,
  id: response.id,
  possibleSolution: response.possibleSolution ?? '',
  possibleSolutionImage: null,
  possibleSolutionImageUrl: response.possibleSolutionImageUrl,
  public: response.public,
  visibleApp: response.visibleApp,
  severity: response.severity,
  status: response.status,
  summary: response.summary,
  title: response.title,
  version: response.version,
});

export const toAppStatusIncidentFormData = (incident: AppStatusIncidentInput): FormData => {
  const formData = new FormData();
  formData.append('date', incident.date);
  formData.append('errorDescription', incident.errorDescription);
  formData.append('possibleSolution', incident.possibleSolution);
  formData.append('public', String(incident.public));
  formData.append('visibleApp', String(incident.visibleApp));
  formData.append('severity', incident.severity);
  formData.append('status', incident.status);
  formData.append('summary', incident.summary);
  formData.append('title', incident.title);
  if (incident.version) formData.append('version', incident.version);
  if (incident.errorDescriptionImage) {
    formData.append('errorDescriptionImage', incident.errorDescriptionImage);
  }
  if (incident.possibleSolutionImage) {
    formData.append('possibleSolutionImage', incident.possibleSolutionImage);
  }
  return formData;
};
